import { app, Component, payload, ojs, state, v } from "modular-openscriptjs";
import { dom } from "../../../fotastart";
import {
    pageInfo,
    redirect,
    either,
    scrollToTop,
    store,
    getStore,
} from "../../../helpers";
import { api, gc, dc } from "../../../declarations";
import { $e } from "../../../ojs.events";

const h = app("h");

export default class SelectCompany extends Component {
    loading = state(false);

    render() {
        pageInfo("Select Business");
        scrollToTop();

        if (dc.companies.value.length === 0) {
            this.loading.value = true;
            this.fetchCompanies();
        } else {
            this.fetchCompanies(true);
        }

        return h.div(
            { class: "min-vh-100 py-5 mb-5 py-md-5" },
            h.div(
                { class: "container py-5" },
                h.div(
                    { class: "text-center mb-5" },
                    h.h1({ class: "display-5 fw-bold mb-3" }, "Welcome back!"),
                    h.p(
                        { class: "lead text-muted" },
                        "Which business are we growing today?",
                    ),
                ),

                v(this.loading, (loading) => {
                    if (loading.value)
                        return h.div(
                            { class: "text-center py-5" },
                            h.Spinner(),
                        );

                    return v(dc.companies, (companies) => {
                        return h.div(
                            { class: "row g-4 justify-content-center" },
                            ...companies.value.map((company) =>
                                this.renderCompanyCard(company),
                            ),

                            // Add New Business Card
                            h.div(
                                { class: "col-12 col-md-6 col-lg-4" },
                                h.div(
                                    {
                                        class: "card border-0 shadow-sm h-100 text-center cursor-pointer border-dashed transition-all hover-translate-y",
                                        style: "border: 2px dashed #dee2e6; border-radius: 24px; background: transparent;",
                                        onclick: h.func(
                                            "app('router').to",
                                            "business.register",
                                        ),
                                    },
                                    h.div(
                                        {
                                            class: "card-body p-5 d-flex flex-column align-items-center justify-content-center",
                                        },
                                        h.div(
                                            {
                                                class: "bg-white text-primary rounded-circle shadow-sm d-flex align-items-center justify-content-center mb-3",
                                                style: "width: 64px; height: 64px;",
                                            },
                                            h.i({
                                                class: "bi bi-plus-lg fs-2",
                                            }),
                                        ),
                                        h.h5(
                                            { class: "fw-bold mb-1" },
                                            "Register New",
                                        ),
                                        h.p(
                                            { class: "text-muted small mb-0" },
                                            "Add another business to Carata",
                                        ),
                                    ),
                                ),
                            ),
                        );
                    });
                }),
            ),
        );
    }

    renderCompanyCard(company) {
        const initials = company.name
            .split(" ")
            .map((n) => n[0])
            .join("")
            .substring(0, 2)
            .toUpperCase();

        return h.div(
            { class: "col-12 col-md-6 col-lg-4" },
            h.div(
                {
                    class: "card border-0 shadow-sm h-100 cursor-pointer overflow-hidden transition-all hover-translate-y",
                    style: "border-radius: 24px;",
                    onclick: this.method("selectCompany", [company]),
                },
                h.div(
                    { class: "card-body p-4 p-lg-5" },
                    h.div(
                        { class: "d-flex align-items-center gap-4" },
                        h.div(
                            {
                                class: "rounded-4 d-flex align-items-center justify-content-center shadow-sm flex-shrink-0",
                                style: "width: 80px; height: 80px; background: linear-gradient(135deg, #973e87 0%, #6f2a63 100%); color: white; font-size: 1.75rem; font-weight: 700;",
                            },
                            initials,
                        ),
                        h.div(
                            { class: "flex-fill overflow-hidden" },
                            h.h4(
                                { class: "fw-bold mb-1 text-truncate" },
                                company.name,
                            ),
                            h.div(
                                { class: "d-flex align-items-center gap-2" },
                                h.span(
                                    {
                                        class: "badge bg-primary-subtle text-primary rounded-pill px-3",
                                    },
                                    `@${company.handle || "id-" + company.id}`,
                                ),
                            ),
                        ),
                    ),
                    h.hr({ class: "my-4 opacity-5" }),
                    h.div(
                        {
                            class: "d-flex justify-content-between align-items-center",
                        },
                        h.div(
                            {},
                            h.div(
                                {
                                    class: "text-muted small text-uppercase fw-bold letter-spacing-1",
                                },
                                "Status",
                            ),
                            h.div(
                                {
                                    class: "fw-bold text-success d-flex align-items-center gap-1",
                                },
                                h.span({
                                    class: "circle bg-success",
                                    style: "--size: 8px;",
                                }),
                                "Active",
                            ),
                        ),
                        h.div(
                            { class: "text-end" },
                            h.div(
                                {
                                    class: "text-muted small text-uppercase fw-bold letter-spacing-1",
                                },
                                "Role",
                            ),
                            h.div({ class: "fw-bold" }, "Owner"),
                        ),
                    ),
                ),
                h.div(
                    {
                        class: "px-4 py-3 border-top d-flex justify-content-between align-items-center",
                    },
                    h.span(
                        { class: "small fw-bold text-muted" },
                        "Switch to this business",
                    ),
                    h.i({
                        class: "bi bi-arrow-right-circle-fill fs-4 text-primary",
                    }),
                ),
            ),
        );
    }

    async fetchCompanies(background = false) {
        if (!background) this.loading.value = true;
        try {
            const res = await api.get("companies");
            if (res) {
                dc.companies.value = res.data.companies;
                window.companies = res.data.companies;
                // store() (see helpers.js) writes to localStorage as well as
                // Preferences - previously this went to Preferences only,
                // same data boot.js's refreshCompanies() now keeps current.
                await store("user_companies", res.data.companies);
            }
        } catch (e) {
            console.error(e);
        } finally {
            if (!background) this.loading.value = false;
        }
    }

    async selectCompany(company) {
        let previousCompany =
            (await getStore("current_company")) || window.currentCompany;

        window.currentCompany = company;
        await store("current_company", company);
        app("inform")(`Switched to ${company.name}`, "success");

        app("broker").send(
            $e.company.has.changed,
            payload({
                previous: previousCompany,
                current: company,
            }),
        );

        redirect().to("home");
    }
}

ojs(SelectCompany);
